export const SWITCH_ROUTES = 'SWITCH_ROUTES';
export const CHANGE_CITY = 'CHANGE_CITY';

export const FETCH_NOW_FORECAST_STARTED = 'FETCH_NOW_FORECAST_STARTED';
export const FETCH_DAILY_FORECAST_STARTED = 'FETCH_DAILY_FORECAST_STARTED';

export const FETCH_NOW_FORECAST_SUCCESS = 'FETCH_NOW_FORECAST_SUCCESS';
export const FETCH_DAILY_FORECAST_SUCCESS = 'FETCH_DAILY_FORECAST_SUCCESS';

export const FETCH_NOW_FORECAST_FAILED = 'FETCH_NOW_FORECAST_FAILED';
export const FETCH_DAILY_FORECAST_FAILED = 'FETCH_DAILY_FORECAST_FAILED';

export const ADD_CITY_CHECK_START = 'ADD_CITY_CHECK_START';
export const ADD_CITY_CHECK_SUCCESS = 'ADD_CITY_CHECK_SUCCESS';
export const REMOVE_CITY = 'REMOVE_CITY';
export const SET_DEFAULT_CITY = 'SET_DEFAULT_CITY';

export const SET_API_KEY = 'SET_API_KEY';
export const SET_UNIT = 'SET_UNIT';

export const GENERATE_MODAL = 'GENERATE_MODAL';
export const DISMISS_MODAL = 'DISMISS_MODAL';